const E = "forgerock-sdk", o = "javascript";
export {
  E as REQUESTED_WITH,
  o as X_REQUESTED_PLATFORM
};
